import * as React from "react"
import Seo from "@components/seo"
import Layout from "@layout"
import Header from "@layout/header/header-four"
import Footer from "@layout/footer/footer-one"
import CTASection from "@containers/global/cta-area/section-two"
import PageHeader from "@components/pageheader"
import DividerSection from "@containers/mantiz-platfotm/dividers-mantiz-platform"
import styled from "styled-components"
import { device } from "@theme"
import parse from "html-react-parser"
import { Container, Row, Col } from "@ui/wrapper"
import Text from "@ui/text"
import Button from "@ui/button"
import SectionTitle from "@ui/section-title"

import { mantizPlataform } from "../dataMantiz/pages/home/mantizPlataform/mantizPlataform"

export const LeftBox = styled.div`
  @media ${device.medium} {
    margin-bottom: 20px;
  }
`

export const RightBox = styled.div``

const AboutPage = ({ pageContext, location }) => (
  <Layout location={location}>
    <Seo title={mantizPlataform.label} />
    <Header />
    <PageHeader
      pageContext={pageContext}
      location={location}
      title={mantizPlataform.title}
      customLabel={mantizPlataform.label}
    />
    <main className="site-wrapper-reveal">
      <br />
      {mantizPlataform.areas.map((item, i) => {
        var tipo = (i + 1) % 2 ? "Impar" : "Par"

        if (tipo == "Impar") {
          return (
            <>
              <Container>
                <Row>
                  <Col lg={{ span: 5, offset: 1 }}>
                    <LeftBox>
                      <img src={item.img} />
                    </LeftBox>
                  </Col>
                  <Col lg={{ span: 5, offset: 1 }}>
                    <SectionTitle title={item.title} />
                    <RightBox>
                      <Text style={{ paddingTop: "20px" }}>
                        {parse(item.description)}
                      </Text>
                      {!item.disableLink && (
                        <Button to={item.path}>Ver más...</Button>
                      )}
                    </RightBox>
                  </Col>
                </Row>
              </Container>
              <DividerSection />
            </>
          )
        } else {
          return (
            <>
              <Container>
                <Row>
                  <Col lg={{ span: 5, offset: 1 }}>
                    <SectionTitle title={item.title} />
                    <LeftBox>
                      <Text style={{ paddingTop: "20px" }}>
                        {parse(item.description)}
                      </Text>
                      {!item.disableLink && (
                        <Button to={item.path}>Ver más...</Button>
                      )}
                    </LeftBox>
                  </Col>
                  <Col lg={{ span: 5, offset: 1 }}>
                    <RightBox>
                      <img src={item.img} />
                    </RightBox>
                  </Col>
                </Row>
              </Container>
              <DividerSection />
            </>
          )
        }
      })}

      <CTASection />
    </main>
    <Footer />
  </Layout>
)

export default AboutPage
